import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('workflow_versions'),
    buttonLoadMoreText: defineMessage('load_more'),
    version: defineMessage('version'),
    by: defineMessage('by'),
};
